import { render, staticRenderFns } from "./quickEntityAddWidget.vue?vue&type=template&id=1902367f&scoped=true"
import script from "./quickEntityAddWidget.vue?vue&type=script&lang=js"
export * from "./quickEntityAddWidget.vue?vue&type=script&lang=js"
import style0 from "./quickEntityAddWidget.vue?vue&type=style&index=0&id=1902367f&prod&lang=css"
import style1 from "./quickEntityAddWidget.vue?vue&type=style&index=1&id=1902367f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1902367f",
  null
  
)

export default component.exports